export default __webpack_public_path__ + "static/media/pipe-mob-safari-14.cc29ba88.png";